import { sectionRenderer } from '@theme/section-renderer';
import { CartUpdateEvent } from '@theme/events';

/**
 * Refreshes the cart drawer (and cart icon) using the theme's Section Rendering API.
 *
 * @param {Object} [options]
 * @param {boolean} [options.openDrawer=false] - Open the cart drawer after refresh
 * @returns {Promise<Object>} The updated cart object from /cart.js
 */
export async function refreshCartDrawer(options = {}) {
  const { openDrawer = false } = options;

  const cartItemsComponents = document.querySelectorAll('cart-items-component');
  /** @type {Map<string, boolean>} */
  const sectionsToRefresh = new Map();

  cartItemsComponents.forEach((component) => {
    if (!(component instanceof HTMLElement) || !component.dataset.sectionId) return;

    const sectionId = component.dataset.sectionId;
    const isDrawer = component.dataset.drawer !== undefined;

    sectionsToRefresh.set(sectionId, isDrawer || sectionsToRefresh.get(sectionId) === true);
  });

  const sectionRefreshPromises = [...sectionsToRefresh.entries()].map(([sectionId, isDrawer]) =>
    sectionRenderer.renderSection(sectionId, {
      cache: false,
      mode: isDrawer ? 'hydration' : 'full',
    })
  );

  const cart = await Promise.all([
    fetch(`${Theme.routes.cart_url}.js`).then((response) => response.json()),
    ...sectionRefreshPromises,
  ]).then(([cartData]) => cartData);

  const drawerCartItems = document.querySelector('cart-items-component[data-drawer]');
  const eventTarget = drawerCartItems || document.querySelector('cart-items-component') || document;

  eventTarget.dispatchEvent(
    new CartUpdateEvent(cart, drawerCartItems?.dataset?.sectionId || 'refresh-cart-drawer', {
      itemCount: cart.item_count,
      source: 'refresh-cart-drawer',
    })
  );

  if (openDrawer) {
    document.querySelector('cart-drawer-component')?.open?.();
  }

  return cart;
}

window.refreshCartDrawer = refreshCartDrawer;

if (typeof Theme !== 'undefined') {
  Theme.refreshCartDrawer = refreshCartDrawer;
}
